import ReactGA from 'react-ga4';

const trackPages = false;
const trackEvents = true;

export const handleGA4PageHit = (data: { page: string, title: string }) => {
	if (trackPages) {
		ReactGA.send({
			hitType: 'pageview',
			page: data.page,
			title: data.title
		});
	}
}

export const handleGA4Event = (data: { category: string, action: string, label: string }) => {
	if (trackEvents) {
		ReactGA.event({
			category: data.category,
			action: data.action,
			label: data.label
		})
	}
}